import dayjs from 'lib/dayjs';

// Dates of an unplanned leave row (old rows without `dates` fall back to their single date)
export const getUnplannedDates = (row) => {
  const dates = row?.dates?.length ? row.dates : [dayjs.utc(row?.date).format('YYYY-MM-DD')];
  return [...dates].sort();
};

// "02 Oct 2026" for one day, "05 Oct – 07 Oct 2026" for several
export const formatUnplannedDates = (dates) => {
  if (dates.length === 1) return dayjs(dates[0]).format('DD MMM YYYY');
  return `${dayjs(dates[0]).format('DD MMM')} – ${dayjs(dates[dates.length - 1]).format('DD MMM YYYY')}`;
};

// Where the unplanned leave stands, from its status and linked leave request
export const getUnplannedState = (row) => {
  if (row.status === 'APPROVED') {
    return { key: 'approved', label: 'Approved', tone: 'bg-green-100 text-green-800' };
  }
  if (row.status === 'CANCELLED') {
    return { key: 'worked', label: 'Log added', tone: 'bg-gray-100 text-gray-700' };
  }
  if (row.status === 'PENDING' && row.leave_request) {
    return { key: 'waiting', label: 'Waiting for approval', tone: 'bg-blue-100 text-blue-800' };
  }
  if (row.status === 'PENDING') {
    return { key: 'action', label: 'Action needed', tone: 'bg-amber-100 text-amber-800' };
  }
  return { key: 'other', label: row.status, tone: 'bg-gray-100 text-gray-700' };
};
